import { PowermeterLiveDataModel } from 'src/Libs/power-meters'
import { ActivationAgreementModel } from '../../Libs/home-power-station/models/home-power-station.model'
import { StorageAction, LiveDataModel, PowermeterHardwareModel, StorageLocation, StorageDataModel, BatteryModel } from './StorageModel'
import { Installation } from 'src/Libs/installations/models/installation.model'

export const setInstallations = (installations: Installation[]): StorageAction => {
  return { type: 'SET_INSTALLATIONS', installations: installations }
}

export const setStorageLoading = (storageLoading: boolean): StorageAction => {
  return { type: 'SET_STORAGE_LOADING', storageLoading }
}

export const addLiveData = (liveData: LiveDataModel): StorageAction => {
  return { type: 'ADD_LIVE_DATA', liveData }
}

export const setPowermeterLiveData = (powermeterLiveData: PowermeterLiveDataModel[]): StorageAction => {
  return { type: 'SET_POWERMETER_LIVE_DATA', powermeterLiveData }
}

export const setPowermeters = (powermeterHardware: PowermeterHardwareModel[]): StorageAction => {
  return { type: 'SET_POWERMETERS', powermeterHardware }
}

export const setLocation = (location: StorageLocation): StorageAction => {
  return { type: 'SET_LOCATION', location }
}

export const setStorageData = (storageData: StorageDataModel): StorageAction => {
  return { type: 'SET_STORAGE_DATA', storageData }
}

export const setInstallation = (installation: Installation): StorageAction => {
  return { type: 'SET_INSTALLATION', installation }
}

export const clearInstallation = (): StorageAction => {
  return { type: 'CLEAR_INSTALLATION' }
}

export const setWarranty = (warranty: ActivationAgreementModel): StorageAction => {
  return { type: 'SET_WARRANTY', warranty }
}

export const addBatteries = (battery: BatteryModel[]): StorageAction => {
  return { type: 'ADD_BATTERIES', battery }
}

export const setStorageColor = (storageColor: 'white' | 'black'): StorageAction => {
  return { type: 'SET_STORAGE_COLOR', storageColor }
}

/**
 * determine which storage is currently viewed => which data should be displayed.
 * Important when a user has multiple storages to choose from
 */
export const setActiveStorage = (activeStorage?: string): StorageAction => {
  if (activeStorage === 'null') {
    return { type: 'SET_ACTIVE_STORAGE', activeStorage: undefined }
  }

  return { type: 'SET_ACTIVE_STORAGE', activeStorage }
}

/**
 * determine the serialnumber of the battery of the system.
 * Important cause Hager systems do not have the battery as active storages sn, so battery status has to be pulled separately
 */
export const setActiveStorageBattery = (activeStorageBattery?: string): StorageAction => {
  return { type: 'SET_ACTIVE_STORAGE_BATTERY', activeStorageBattery }
}

/**
 * determine which installation is currently viewed => which data should be displayed.
 * will reset the active storage to undefined if a 'null' is provided, as a change of installation without a storageId (construction-installation) should delete the previous one
 * will reuse the prev. storageID if its set to 'undefined'
 */
export const setActiveInstallation = (activeInstallation?: number, activeStorage?: string | null): StorageAction => {
  return { type: 'SET_ACTIVE_INSTALLATION', activeInstallation, activeStorage }
}

/**
 * This action creator resets active storage, installation and storage battery to default values
 */
export const resetActiveValues = (): StorageAction => {
  return { type: 'RESET_ACTIVE_VALUES_TO_INITIAL' }
}

export const setStoreInitialised = (): StorageAction => {
  return { type: 'SET_STORE_INITIALISED' }
}
